import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _styled from "@emotion/styled-base";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import { defaultValue as originalDefaultValue, container as originalContainer, propName as originalPropName, propType as originalPropType, right as originalRight } from 'gatsby-theme-docz/src/components/Props/styles';
export var Container = _styled("div", {
  target: "e1rvvg8g0"
})("width:100%;overflow:auto;margin-bottom:2rem;table{width:100%;text-align:left;border-collapse:collapse;vertical-align:middle;font-size:0.9em;th,td{border-bottom:solid 1px ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
}, ";padding:12px 8px;min-height:68px;}th{color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.gray;
}, ";}td{p{margin:0;}}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

if (typeof Container !== 'undefined' && Container && Container === Object(Container) && Object.isExtensible(Container) && !Object.prototype.hasOwnProperty.call(Container, '__filemeta')) {
  Object.defineProperty(Container, '__filemeta', {
    configurable: true,
    value: {
      name: "Container",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Props/custom-styles.js"
    }
  });
}

export var container = _objectSpread(_objectSpread({}, originalContainer), {}, {
  overflow: 'none'
});

if (typeof container !== 'undefined' && container && container === Object(container) && Object.isExtensible(container) && !Object.prototype.hasOwnProperty.call(container, '__filemeta')) {
  Object.defineProperty(container, '__filemeta', {
    configurable: true,
    value: {
      name: "container",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Props/custom-styles.js"
    }
  });
}

export var propName = _objectSpread(_objectSpread({}, originalPropName), {}, {
  minWidth: '150px'
});

if (typeof propName !== 'undefined' && propName && propName === Object(propName) && Object.isExtensible(propName) && !Object.prototype.hasOwnProperty.call(propName, '__filemeta')) {
  Object.defineProperty(propName, '__filemeta', {
    configurable: true,
    value: {
      name: "propName",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Props/custom-styles.js"
    }
  });
}

export var propType = _objectSpread(_objectSpread({}, originalPropType), {}, {
  minWidth: '150px'
});

if (typeof propType !== 'undefined' && propType && propType === Object(propType) && Object.isExtensible(propType) && !Object.prototype.hasOwnProperty.call(propType, '__filemeta')) {
  Object.defineProperty(propType, '__filemeta', {
    configurable: true,
    value: {
      name: "propType",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Props/custom-styles.js"
    }
  });
}

export var right = _objectSpread(_objectSpread({}, originalRight), {}, {
  minWidth: '150px'
});

if (typeof right !== 'undefined' && right && right === Object(right) && Object.isExtensible(right) && !Object.prototype.hasOwnProperty.call(right, '__filemeta')) {
  Object.defineProperty(right, '__filemeta', {
    configurable: true,
    value: {
      name: "right",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Props/custom-styles.js"
    }
  });
}

export var defaultValue = _objectSpread(_objectSpread({}, originalDefaultValue), {}, {
  maxWidth: '50%',
  overflow: 'hidden',
  color: function color(theme) {
    return "" + theme.colors.props.descriptionText;
  },
  '&[data-hovertext]': {
    cursor: 'help',
    whiteSpace: 'nowrap'
  },
  '&[data-hovertext] > em': {
    display: 'block',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  '&[data-hovertext]:hover::before': {
    content: 'attr(data-hovertext)',
    position: 'absolute',
    padding: '10px 20px',
    background: function background(theme) {
      return "" + theme.colors.props.descriptionBg;
    },
    color: function color(theme) {
      return "" + theme.colors.props.descriptionText;
    },
    border: function border(theme) {
      return "1px solid " + theme.colors.props.descriptionText;
    },
    borderRadius: 10,
    whiteSpace: 'pre-wrap',
    fontStyle: 'italic',
    zIndex: 10
  }
});

if (typeof defaultValue !== 'undefined' && defaultValue && defaultValue === Object(defaultValue) && Object.isExtensible(defaultValue) && !Object.prototype.hasOwnProperty.call(defaultValue, '__filemeta')) {
  Object.defineProperty(defaultValue, '__filemeta', {
    configurable: true,
    value: {
      name: "defaultValue",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Props/custom-styles.js"
    }
  });
}